import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _styled from "@emotion/styled-base";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import { defaultValue as originalDefaultValue, container as originalContainer, propName as originalPropName, propType as originalPropType, right as originalRight } from 'gatsby-theme-docz/src/components/Props/styles';
export var Container = _styled("div", {
  target: "e1rvvg8g0"
})("width:100%;overflow:auto;margin-bottom:2rem;table{width:100%;text-align:left;border-collapse:collapse;vertical-align:middle;font-size:0.9em;th,td{border-bottom:solid 1px ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
}, ";padding:12px 8px;min-height:68px;}th{color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.gray;
}, ";}td{p{margin:0;}}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

if (typeof Container !== 'undefined' && Container && Container === Object(Container) && Object.isExtensible(Container) && !Object.prototype.hasOwnProperty.call(Container, '__filemeta')) {
  Object.defineProperty(Container, '__filemeta', {
    configurable: true,
    value: {
      name: "Container",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Props/custom-styles.js"
    }
  });
}

export var container = _objectSpread(_objectSpread({}, originalContainer), {}, {
  overflow: 'none'
});

if (typeof container !== 'undefined' && container && container === Object(container) && Object.isExtensible(container) && !Object.prototype.hasOwnProperty.call(container, '__filemeta')) {
  Object.defineProperty(container, '__filemeta', {
    configurable: true,
    value: {
      name: "container",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Props/custom-styles.js"
    }
  });
}

export var propName = _objectSpread(_objectSpread({}, originalPropName), {}, {
  minWidth: '150px'
});

if (typeof propName !== 'undefined' && propName && propName === Object(propName) && Object.isExtensible(propName) && !Object.prototype.hasOwnProperty.call(propName, '__filemeta')) {
  Object.defineProperty(propName, '__filemeta', {
    configurable: true,
    value: {
      name: "propName",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Props/custom-styles.js"
    }
  });
}

export var propType = _objectSpread(_objectSpread({}, originalPropType), {}, {
  minWidth: '150px'
});

if (typeof propType !== 'undefined' && propType && propType === Object(propType) && Object.isExtensible(propType) && !Object.prototype.hasOwnProperty.call(propType, '__filemeta')) {
  Object.defineProperty(propType, '__filemeta', {
    configurable: true,
    value: {
      name: "propType",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Props/custom-styles.js"
    }
  });
}

export var right = _objectSpread(_objectSpread({}, originalRight), {}, {
  minWidth: '150px'
});

if (typeof right !== 'undefined' && right && right === Object(right) && Object.isExtensible(right) && !Object.prototype.hasOwnProperty.call(right, '__filemeta')) {
  Object.defineProperty(right, '__filemeta', {
    configurable: true,
    value: {
      name: "right",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Props/custom-styles.js"
    }
  });
}

export var defaultValue = _objectSpread(_objectSpread({}, originalDefaultValue), {}, {
  maxWidth: '50%',
  overflow: 'hidden',
  color: function color(theme) {
    return "" + theme.colors.props.descriptionText;
  },
  '&[data-hovertext]': {
    cursor: 'help',
    whiteSpace: 'nowrap'
  },
  '&[data-hovertext] > em': {
    display: 'block',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  '&[data-hovertext]:hover::before': {
    content: 'attr(data-hovertext)',
    position: 'absolute',
    padding: '10px 20px',
    background: function background(theme) {
      return "" + theme.colors.props.descriptionBg;
    },
    color: function color(theme) {
      return "" + theme.colors.props.descriptionText;
    },
    border: function border(theme) {
      return "1px solid " + theme.colors.props.descriptionText;
    },
    borderRadius: 10,
    whiteSpace: 'pre-wrap',
    fontStyle: 'italic',
    zIndex: 10
  }
});

if (typeof defaultValue !== 'undefined' && defaultValue && defaultValue === Object(defaultValue) && Object.isExtensible(defaultValue) && !Object.prototype.hasOwnProperty.call(defaultValue, '__filemeta')) {
  Object.defineProperty(defaultValue, '__filemeta', {
    configurable: true,
    value: {
      name: "defaultValue",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Props/custom-styles.js"
    }
  });
}